// PO 管理 / 配給 API layer(S31/AL)— 後端 = ca-manager,經 restful 白名單代理
// /v3/admin/pos*(→ ca-manager /admin/pos)。建 PO 即從憑證池配滿(allocate-at-
// create)。reason/case_id 必填(治理)。{data}/{error} 信封 + cursor 分頁。
import { apiFetch, normalizeCursor } from '../../lib/api';

export type POStatus = 'open' | 'confirmed' | 'cancelled';

export interface POItem {
  type: string;
  amount: number;
  used: number;
  remain: number;
}
export interface POTotals {
  amount: number;
  used: number;
  remain: number;
}
export interface PO {
  po_number: string;
  org_id: string;
  org_name_snapshot: string;
  status: POStatus | string;
  created_at?: string | null;
  totals: POTotals;
  items?: POItem[];
}

export interface ListPOParams {
  org_id?: string;
  status?: string;
  cursor?: string;
  limit?: number;
}
export interface POPage {
  items: PO[];
  nextCursor: string | null;
}

export async function listPOs(p: ListPOParams = {}): Promise<POPage> {
  const res = await apiFetch<{ items?: PO[]; next_cursor?: string }>('/v3/admin/pos', {
    query: { org_id: p.org_id, status: p.status, cursor: p.cursor, limit: p.limit },
  });
  return {
    items: Array.isArray(res.data?.items) ? res.data.items : [],
    nextCursor: normalizeCursor(res.data?.next_cursor),
  };
}

export async function getPO(poNumber: string): Promise<PO> {
  const res = await apiFetch<PO>(`/v3/admin/pos/${encodeURIComponent(poNumber)}`);
  return res.data;
}

export interface CreatePOItem {
  type: string;
  amount: number;
}
export interface CreatePOBody {
  po_number: string;
  org_id: string;
  org_name: string; // 從 picker 帶入(D6:restful 已驗 approved)
  items: CreatePOItem[];
  reason: string;
  case_id: string;
}

export async function createPO(body: CreatePOBody): Promise<{ po_number: string }> {
  const res = await apiFetch<{ po_number: string }>('/v3/admin/pos', { method: 'POST', body });
  return res.data;
}

export async function cancelPO(poNumber: string, reason: string, caseId: string): Promise<{ status: string; returned: number }> {
  const res = await apiFetch<{ status: string; returned: number }>(
    `/v3/admin/pos/${encodeURIComponent(poNumber)}/cancel`,
    { method: 'POST', body: { reason, case_id: caseId } },
  );
  return res.data;
}

export function poStatusLabel(s?: string): string {
  switch (s) {
    case 'open':
      return '開立';
    case 'confirmed':
      return '已確認';
    case 'cancelled':
      return '已取消';
    default:
      return s ?? '—';
  }
}
export function poStatusTone(s?: string): string {
  switch (s) {
    case 'open':
      return 'pill-info';
    case 'confirmed':
      return 'pill-good';
    case 'cancelled':
      return 'pill-neutral';
    default:
      return 'pill-neutral';
  }
}
